const METERS_PER_DEGREE_LATITUDE = 111_320;
const MIN_LONGITUDE_COSINE = 1e-6;

export function parseFiniteCoordinate(value) {
  const parsed = typeof value === 'number' ? value : Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function normalizeNegativeZero(value) {
  return Object.is(value, -0) ? 0 : value;
}

function roundToStep(value, step) {
  return normalizeNegativeZero(Math.round(value / step) * step);
}

export function latitudeStepForNearestMeter() {
  return 1 / METERS_PER_DEGREE_LATITUDE;
}

export function longitudeStepForNearestMeter(latitude) {
  const lat = parseFiniteCoordinate(latitude) ?? 0;
  const cosine = Math.abs(Math.cos((lat * Math.PI) / 180));

  if (cosine < MIN_LONGITUDE_COSINE) {
    return latitudeStepForNearestMeter();
  }

  return 1 / (METERS_PER_DEGREE_LATITUDE * cosine);
}

export function quantizeLatitudeToNearestMeter(latitude) {
  const lat = parseFiniteCoordinate(latitude);
  if (lat === null) return latitude;

  return roundToStep(lat, latitudeStepForNearestMeter());
}

export function quantizeLongitudeToNearestMeter(longitude, latitude = 0) {
  const lon = parseFiniteCoordinate(longitude);
  if (lon === null) return longitude;

  return roundToStep(lon, longitudeStepForNearestMeter(latitude));
}

export function quantizeGpsPairToNearestMeter(latitude, longitude) {
  const lat = parseFiniteCoordinate(latitude);
  const lon = parseFiniteCoordinate(longitude);

  return {
    latitude: lat === null ? latitude : quantizeLatitudeToNearestMeter(lat),
    longitude:
      lon === null ? longitude : quantizeLongitudeToNearestMeter(lon, lat ?? 0),
  };
}
